import React, { useState } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { authAPI, activitiesAPI } from '../api/client';
import '../styles/auth.css';

export default function Register() {
  const [phone_email, setPhoneEmail] = useState('');
  const [display_name, setDisplayName] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const params = new URLSearchParams(location.search);
  const redirectTo = params.get('redirect') || '/feed';
  const intent = params.get('intent');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    if (password.length < 6) {
      setError('Password must be at least 6 characters');
      return;
    }

    setLoading(true);

    try {
      const response = await authAPI.register(phone_email, display_name, password);
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('userId', response.data.userId);
      if (display_name) localStorage.setItem('displayName', display_name);

      // Auto-RSVP if intent=rsvp and redirect points to an activity
      if (intent === 'rsvp' && redirectTo.startsWith('/activity/')) {
        const activityId = redirectTo.split('/activity/')[1];
        try { await activitiesAPI.rsvp(activityId, 'im_in'); } catch {}
        navigate(redirectTo);
      } else if (redirectTo === '/feed') {
        // New user with no redirect — send to onboarding
        navigate('/onboarding');
      } else {
        navigate(redirectTo);
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Registration failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-card-inner">
          <span className="auth-logo">covo</span>
          <h1 className="auth-heading">Get started for free</h1>
          <p className="auth-sub">No credit card required.</p>

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Email or Phone</label>
              <input
                type="text"
                value={phone_email}
                onChange={(e) => setPhoneEmail(e.target.value)}
                placeholder="you@example.com"
                required
                autoFocus
              />
            </div>

            <div className="form-group">
              <label>Your name</label>
              <input
                type="text"
                value={display_name}
                onChange={(e) => setDisplayName(e.target.value)}
                placeholder="Alex"
                required
              />
            </div>

            <div className="form-group">
              <label>Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                required
              />
            </div>

            <div className="form-group">
              <label>Confirm password</label>
              <input
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                placeholder="••••••••"
                required
              />
            </div>

            {error && <div className="error-message">{error}</div>}

            <button type="submit" className="btn-primary" disabled={loading}>
              {loading ? 'Creating account…' : 'Create account'}
            </button>
          </form>

          <p className="auth-link">
            Already have an account? <Link to={`/login${location.search}`}>Sign in</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
